import { translate } from "../../utils/translation";
import { comma } from "../../helpers/common.functions";
import PropTypes from "prop-types";

/// props validation | SQ(javascript:S6774)
Legend.propTypes = {
  data: PropTypes.object,
  colours: PropTypes.array,
  thisBenchmark: PropTypes.object,
};
///
export function Legend(props) {
  const { data, colours, thisBenchmark } = props;
  //Show legend with value only when there is a value
  const legend = data
    .map((o, i) => {
      if (o.value !== 0) {
        return {
          ...o,
          colour: colours[i],
        };
      }
      return null;
    })
    .filter(Boolean); // remove nulls

  let displayTotal = Math.round(sum(legend));

  const constructionCost = thisBenchmark?.construction_cost;
  // Calculate Difference
  const difference = constructionCost - displayTotal;
  // Difference is less than positive 5 it is rounding only
  if (difference <= 5) {
    displayTotal = constructionCost;
  }

  // Difference is less than negative -5 it is rounding only
  if (difference >= -5) {
    displayTotal = constructionCost;
  }

  let total = {
    quantity: Math.round(displayTotal),
    name: translate("Total Construction Cost"),
    total: true,
    colour: null,
  };

  legend.push(total);

  return legend.map((item) => {
    let classType = "estimate-benchmark-legend-row";

    if (item.total) {
      return (
        <div className={classType} key={item.name}>
          <div className="estimate-benchmark-legend-label">
            <div
              className="estimate-benchmark-legend-circle"
              style={{ backgroundColor: item.colour }}
            />
            <b>{item.name}</b>
          </div>
          <div className="estimate-benchmark-legend-number">
            <b> {comma(item.quantity)}</b>
          </div>
        </div>
      );
    }

    return (
      <div className={classType} key={item.name}>
        <div className="estimate-benchmark-legend-label">
          <div
            className="estimate-benchmark-legend-circle"
            style={{ backgroundColor: item.colour }}
          />
          {item.name}
        </div>
        <div className="estimate-benchmark-legend-number">
          {comma(item.quantity)}
        </div>
      </div>
    );
  });
}

function sum(array) {
  let theSum = 0;

  array.forEach((item) => {
    theSum += item.quantity || 0;
  });

  return theSum;
}
